<template lang="pug">
  .popup-text-container(v-if="isVisible")
    span.popup(:style="{color: color}")
</template>

<script>
export default {
  name: 'PopupText',
  props: {
    value: String,
    color: {
      type: String,
      default: 'black'
    }
  },
  data () {
    return {
      isVisible: true
    }
  },
  mounted () {
    const popup = this.$el.querySelector('.popup')
    popup.dataset.content = this.value
    popup.addEventListener('animationend', () => {
      this.isVisible = false
    })
  }
}
</script>

<style lang="styl" scoped>
  .popup-text-container
    position relative
    width 100%

  .popup
    position absolute
    animation popup 1.5s 1

  .popup:after
    content attr(data-content)
    font-size 1.2em

  @keyframes popup
    0%
      opacity 1
      transform translateY(0)

    100%
      opacity 0
      transform translateY(-100px)
      display none
</style>
